import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { addClass } from '../utils';

axios.interceptors.request.use((request) => {
  if (request.method === 'get') {
    request.params = _.assign(request.params, { _: _.now() });
  }
  return request;
});
axios.defaults.headers.common['Accept-Language'] = 'ko-KR';

const get = (url, data, config) => {
  const params = _.omit(_.pickBy(data), 'files');
  return axios.get(url, _.assign(config, { params }));
};

const del = (url, data, config) => {
  const params = _.omit(_.pickBy(data), 'files');
  return axios.delete(url, _.assign(config, { params }));
};
const post = (url, data, config) => {
  let nData = '';
  if (typeof data === 'string') nData = data;
  else {
    const params = _.omit(data, 'files');
    nData = qs.stringify(params);
  }
  return axios.post(url, nData, config);
};

const put = (url, data, config) => {
  let nData = '';
  if (typeof data === 'string') nData = data;
  else {
    const params = _.pickBy(data);
    nData = qs.stringify(params);
  }
  return axios.put(url, nData, config);
};

const multipart = (url, data, config) => {
  _.assign(config, { headers: { 'content-type': 'multipart/form-data' } });
  const formData = new FormData();
  const params = _.omit(_.pickBy(data), 'files');
  _.forEach(params, (item, key) => {
    if (`${item}` === 'FILE_INPUT_MODEL') {
      _.forEach(item.add, (file) => {
        formData.append(key, file);
      });
      _.forEach(item.remove, (remove) => {
        formData.append('removeFiles', remove);
      });
    } else {
      formData.append(key, item);
    }
  });
  return axios.post(url, formData, config);
};

const validation = (el, option) => {
  const errors = el.querySelectorAll('.error');
  if (errors.length) {
    let fn = alert;
    if (typeof option === 'function') {
      fn = option;
    } else {
      addClass(el, 'requested');
    }
    fn(errors[0].getAttribute('title') || '필수항목이 누락되었습니다');
    const input = (errors[0].tagName === 'INPUT' || errors[0].tagName === 'TEXTAREA') ? errors[0] : errors[0].querySelector('input, textarea');
    if (input) input.focus();
  }
  return errors.length === 0;
};

export default {
  get,
  post,
  multipart,
  put,
  delete: del,
  validation,
  stringify: qs.stringify,
};



// WEBPACK FOOTER //
// ./src/utils/oax.js